// assets
import { CalendarOutlined, BankOutlined, AuditOutlined, ProfileOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

// icons
const icons = {
  CalendarOutlined,
  BankOutlined,
  AuditOutlined,
  ProfileOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const events = {
  id: 'events_parent',
  title: '',
  type: 'group',
  children: [
    {
      id: 'events',
      title: <FormattedMessage id="events.events" />,
      type: 'collapse',
      icon: icons.CalendarOutlined,
      children: [
        {
          id: 'seminar',
          title: <FormattedMessage id="events.seminar" />,
          icon: icons.ContactsOutlined,
          url: '/events/seminar',
          type: 'item'
        }
      ]
    }
  ]
};

export default events;
